module.exports = __webpack_public_path__ + "static/media/entregasubsidiocierre.52b191ec.jpg";